import {
  UNSET_CURRENT_PRODUCT,
  SET_CURRENT_PRODUCT,
  SET_PRODUCTS_STATE
} from '../config/const';
import {SET_ACTIVE_CATEGORY_INDEX} from "../actions/api";

export const FETCH_PRODUCTS_COMPLETE = 'FETCH_PRODUCTS_COMPLETE';
export const SEARCH_PRODUCTS = 'SEARCH_PRODUCTS';

const products = {
  data: [],
  currentCategoryIndex: -1,
  activeCategoryIndex: -1,
  currentCategoryCount: 0,
  totalPages: 0, // total pages of selected category
  isInfiniteScroll: true, // scroll view,
  fetching: false,
  changingCategory: false,
  currentProduct: null,
  lastKey: null
};

const productReducer = (state = products, action) => {
  switch (action.type) {
  case 'SET_FETCHING_DATA': {
    state = {...state, fetching: action.payload};
    break;
  }
  case 'SET_PRODUCT_FETCHING': {
    state = {...state, fetching: action.payload};
    break;
  }
  case 'SET_CHANGING_CATEGORY': {
    state = {...state, changingCategory: action.payload};
    break;
  }
  case 'CONCAT_PRODUCTS_DATA': {
    const {data} = action.payload;
    const productList = state.data.concat(data.productGrouplist);
    // let products = {};
    // data.productGrouplist.forEach(product => {
    //  products[product.id] = product;
    // });
    const pageItemsSize = data.productGrouplist.length;
    const totalPages = data.totalPages;
    state = {...state, data: productList, totalPages, currentCategoryCount: state.currentCategoryCount + pageItemsSize};
    break;
  }
  case 'SET_PRODUCTS_DATA': {
    const {data} = action.payload;
    const productList = [...data.productGrouplist];
    const pageItemsSize = data.productGrouplist.length;
    const totalPages = data.totalPages;
    return {...state, data: productList, totalPages, currentCategoryCount: pageItemsSize};
  }
  case 'SET_CATEGORY': {
    state = {...state, currentCategoryIndex: action.payload, currentCategoryCount: 0, totalPages: 0};
    break;
  }
  case SET_ACTIVE_CATEGORY_INDEX: {
    return {
      ...state,
      activeCategoryIndex: action.payload,
    };
  }
  case 'CLEAN_PRODUCTS_DATA': {
    state = {...state, data: []};
    break;
  }
  case 'SET_INFINITE_SCROLL': {
    state = {...state, isInfiniteScroll: action.payload};
    break;
  }
  case SET_CURRENT_PRODUCT: {
    state = {...state, currentProduct: action.payload};
    break;
  }
  case UNSET_CURRENT_PRODUCT: {
    state = {...state, currentProduct: null};
    break;
  }
  case SET_PRODUCTS_STATE: {
    return action.payload;
  }
  case 'SET_CURRENT_CATEGORY_INDEX': {
    return {
      ...state,
      currentCategoryIndex: action.payload
    };
  }
  default: {
    break;
  }
  }
  return state;
};

export const isCategoryToFetch = (state) => state.products.currentCategoryIndex < state.config.categories.length - 1;

export default productReducer;



// WEBPACK FOOTER //
// ./src/reducers/productReducer.js